// extracted by mini-css-extract-plugin
export default {"link":"style_link__FWtfT","centerGrid":"style_centerGrid__beZCI","img":"style_img__eU3xz","namegame":"style_namegame__dBBIi","center":"style_center__RfuuA"};